import { render, staticRenderFns } from "./GoodIssued.vue?vue&type=template&id=c81a32a4"
import script from "./GoodIssued.vue?vue&type=script&lang=js"
export * from "./GoodIssued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports